<template>
  <div class="pdf-preview">
    <div v-if="loading" class="loading">
      <div class="loading-spinner"></div>
      <div>正在加载简历...</div>
    </div>
    <div v-else-if="error" class="error">
      <div class="error-icon">⚠️</div>
      <div>{{ errorMessage }}</div>
    </div>
    <div v-else class="pages-container">
      <div v-for="(page, index) in pages" :key="index" class="page">
        <img :src="page" :alt="`简历第 ${index + 1} 页`">
        <div class="page-info">第 {{ index + 1 }} / {{ totalPages }} 页</div>
      </div>
    </div>
    <div class="bottom-bar">
      <div class="interest-list">
        <div class="item" @click="selectScore(4)"><img :src="scoreStatus === 4 ? rejectActiveIcon : rejectIcon" alt=""><div :class="{ active: scoreStatus === 4 }">不合适</div></div>
        <div class="item" @click="selectScore(3)"><img :src="scoreStatus === 3 ? pendingActiveIcon : pendingIcon" alt=""><div :class="{ active: scoreStatus === 3 }">待定</div></div>
        <div class="item" @click="selectScore(2)"><img :src="scoreStatus === 2 ? interestActiveIcon : interestIcon" alt=""><div :class="{ active: scoreStatus === 2 }">感兴趣</div></div>
      </div>
      <div class="btn btn-contact">沟通联系</div>
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist/build/pdf'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

export default {
  name: 'PreviewResumePdf',
  data() {
    return {
      loading: true,
      error: false,
      errorMessage: '',
      pages: [],
      totalPages: 0,
      pdfUrl: '',
      scoreStatus: 0,
      loadingTask: null,
      leaveWarningVisible: false,
      rejectIcon: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/ruser1.png',
      rejectActiveIcon: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/aui1.png',
      pendingIcon: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/ruser2.png',
      pendingActiveIcon: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/aui2.png',
      interestIcon: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/ruser4.png',
      interestActiveIcon: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/aui4.png'
    }
  },
  mounted() {
    document.title = '预览简历'
    this.pdfUrl = this.$route.query.pdfurl || ''
    this.scoreStatus = parseInt(this.$route.query.score_status, 10) || 0
    this.loadPdfAndRender()
  },
  beforeDestroy() {
    if (this.loadingTask) this.loadingTask.destroy()
  },
  beforeRouteLeave(to, from, next) {
    if (this.scoreStatus) return next()
    if (this.leaveWarningVisible) return next(false)

    this.leaveWarningVisible = true
    this.$alert('您需要先对简历标记状态', '提示', {
      confirmButtonText: '我知道了',
      closeOnClickModal: false
    }).then(() => {
      this.leaveWarningVisible = false
      next(false)
    }).catch(() => {
      this.leaveWarningVisible = false
      next(false)
    })
  },
  methods: {
    selectScore(type) {
      this.scoreStatus = type
    },
    async loadPdfAndRender() {
      if (!this.pdfUrl || typeof this.pdfUrl !== 'string' || !/^https?:\/\//i.test(this.pdfUrl)) {
        this.loading = false
        this.error = true
        this.errorMessage = 'PDF URL无效，请检查预览链接'
        return
      }
      try {
        this.loadingTask = pdfjsLib.getDocument(this.pdfUrl)
        const pdf = await this.loadingTask.promise
        this.totalPages = pdf.numPages
        const pageImages = []
        for (let index = 1; index <= this.totalPages; index++) {
          const page = await pdf.getPage(index)
          const viewport = page.getViewport({ scale: 2 })
          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')
          canvas.width = viewport.width
          canvas.height = viewport.height
          await page.render({ canvasContext: context, viewport }).promise
          pageImages.push(canvas.toDataURL('image/png'))
        }
        this.pages = pageImages
      } catch (error) {
        const message = error && error.message ? error.message : ''
        this.error = true
        if (/Invalid PDF structure/.test(message)) this.errorMessage = 'PDF文件无效或链接已过期'
        else if (/Failed to fetch|NetworkError/.test(message)) this.errorMessage = '网络错误，无法加载PDF文件'
        else if (/Missing PDF/.test(message)) this.errorMessage = '找不到PDF文件，链接可能已失效'
        else this.errorMessage = '加载PDF失败'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.pdf-preview { min-height: 100vh; padding: 20px; background: #f5f5f5; }
.loading, .error { min-height: calc(100vh - 130px); display: flex; flex-direction: column; align-items: center; justify-content: center; color: #666; }
.error { color: #ff3b30; }
.error-icon { margin-bottom: 16px; font-size: 48px; }
.loading-spinner { width: 50px; height: 50px; margin-bottom: 16px; border: 4px solid #e0e0e0; border-top-color: #007aff; border-radius: 50%; animation: spin 1s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.pages-container { width: 900px; max-width: 100%; margin: 0; }
.page { margin-bottom: 16px; overflow: hidden; background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0, 0, 0, .1); }
.page img { display: block; width: 100%; height: auto; }
.page-info { padding: 12px; color: #999; font-size: 14px; text-align: center; border-top: 1px solid #f0f0f0; }
.bottom-bar { display: flex; align-items: center; justify-content: center; box-sizing: border-box; width: 900px; max-width: 100%; padding: 10px 24px; background: #fff; box-shadow: 0 2px 8px rgba(0, 0, 0, .1); }
.interest-list { display: flex; width: 360px; }
.item { flex: 1; color: #5c5c5c; font-size: 14px; text-align: center; cursor: pointer; }
.item img { display: block; width: 32px; height: 32px; margin: 0 auto 4px; }
.item .active { color: #ff6600; }
.btn { width: 136px; height: 40px; margin-left: 30px; color: #fff; font-size: 15px; font-weight: 600; line-height: 40px; text-align: center; background: #ff6c00; border-radius: 8px; }
@media screen and (max-width: 600px) { .pdf-preview { padding: 10px; } .bottom-bar { padding: 10px; } .interest-list { flex: 1; } .btn { width: 110px; margin-left: 10px; } }
</style>
